import { render, staticRenderFns } from "./popup-set-unit.vue?vue&type=template&id=2487e8d9&scoped=true"
import script from "./popup-set-unit.vue?vue&type=script&lang=js"
export * from "./popup-set-unit.vue?vue&type=script&lang=js"
import style0 from "./popup-set-unit.vue?vue&type=style&index=0&id=2487e8d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487e8d9",
  null
  
)

export default component.exports